import {put, takeLatest, call} from 'redux-saga/effects';
import * as productService from "../../../../services/productService";
import {
    UPDATE_PRODUCT_LISTS,
    UPDATE_PRODUCT_LISTS_SUCCESS,
    UPDATE_PRODUCT_LISTS_ERROR,
}
    from "../../../actions/menu/products";

function* updateProductListsSaga(action) {
    try {
        const data=yield call(productService.UpdateProductLists,action.payload)
        yield put({
            type: UPDATE_PRODUCT_LISTS_SUCCESS,
            payload: {product : data, params : action.payload.data}
        });


    } catch(error) {
        yield put({
            type: UPDATE_PRODUCT_LISTS_ERROR,error: error.data
        });
    }
}


export function* updateProductListsSagaWatcher() {
    yield takeLatest(UPDATE_PRODUCT_LISTS, updateProductListsSaga);
}